import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useStudentCredential,
  useFind: useStudentCredentials,
  useCreate: useStudentCredentialCreation,
  useUpdate: useStudentCredentialUpdate,
  useDelete: useStudentCredentialDeletion,
} = getCRUDHooks({
  entityName: 'student-credentials',
});

export {
  useStudentCredential,
  useStudentCredentials,
  useStudentCredentialCreation,
  useStudentCredentialUpdate,
  useStudentCredentialDeletion,
};
